// Implements: .fs-chip from ui_kits/rehaut-flagships/flagship.css.
// Status pill in the four state tones; `solid` for the hot variant
// (e.g. the urgencia counter on HOY).
import type { CSSProperties, ReactNode } from 'react';

export type ChipTone = 'error' | 'warn' | 'ok' | 'neutral';

export function Chip({
  tone = 'neutral',
  solid = false,
  children,
  style,
}: {
  tone?: ChipTone;
  solid?: boolean;
  children: ReactNode;
  style?: CSSProperties;
}) {
  const cls = ['fs-chip', tone, solid ? 'solid' : null].filter(Boolean).join(' ');
  return <span className={cls} style={style}>{children}</span>;
}
